import script from "./GgmsDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsDropdown.vue?vue&type=style&index=0&id=0c1741c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1741c3"]])

export default __exports__